import * as actionTypes from '../../types/user';

export const initialState = {
  isAuth: false,
  isLoading: true,
  error: null,
  loaderText: '',
};

const user = (state = initialState, action) => {
  switch (action.type) {
  case actionTypes.USER_AUTH_LOADING: {
    return {
      ...state,
      isLoading: action.payload.isLoading,
    }
  }
  case actionTypes.USER_AUTH_SUCCESS: {
    return {
      ...state,
      isLoading: false,
      isAuth: true,
      error: null,
      loaderText: '',
    };
  }
  case actionTypes.USER_REFRESH_SUCCESS: {
    return {
      ...state,
      isLoading: true,
      isAuth: true,
      error: null,
      loaderText: '',
    };
  }
  case actionTypes.USER_AUTH_ERROR: {
    return {
      ...state,
      isLoading: false,
      isAuth: false,
    };
  }
  case actionTypes.USER_AUTH_LOGOUT: {
    return {
      ...state,
      isLoading: true,
      isAuth: false,
    };
  }
  case actionTypes.USER_AUTH_UNAUTHORIZED: {
    return {
      ...state,
      isLoading: true,
      isAuth: false,
      loaderText: 'Check credentials...',
    };
  }
  case actionTypes.USER_AUTH_LOGOUT_CREDENTIALS: {
    return {
      ...state,
      isLoading: false,
      isAuth: false,
      error: action?.payload?.error || null,
    };
  }
  case actionTypes.USER_SUPER_ADMIN_AUTH_SUCCESS: {
    return {
      ...state,
      isLoading: true,
      isAuth: true,
      error: null,
    };
  }

  default: {
    break;
  }
  }

  return state;
};

export default user;
